import {
  RecruitingInvitationSortField,
  RecruitingInvitationSortOrder,
} from '../constants'

export enum RecruitingExemptStatusEnum {
  Exempt = 'Exempt',
  NonExempt = 'Non-Exempt',
}

export enum RecruitingEmploymentStatusEnum {
  FullTime = 'Full-Time',
  PartTime = 'Part-Time',
}

export enum RecruitingPayTypeEnum {
  Hourly = 'Hourly',
  Salary = 'Salary',
}
export type InvitationDateFilters = {
  benefitEffectiveStartDate?: string
  benefitEffectiveEndDate?: string
}

export type InvitationListFilters = InvitationDateFilters & {
  sort?: string
  order?: string
  status?: string
  page?: string
  pageSize?: string
}

export type ResolvedInvitationPaginationParams = {
  page: number
  pageSize: number
}

export type ResolvedInvitationSortParams = {
  sort: RecruitingInvitationSortField
  order: RecruitingInvitationSortOrder
}

export type ResolvedInvitationDateFilters = {
  benefitEffectiveStartDate: string
  benefitEffectiveEndDate: string
}

export interface CreateInvitationFormValues {
  benefitEffectiveDate: Date
  expiryDays: number
  contributionGroup: string
  exemptStatus: RecruitingExemptStatusEnum
  employmentStatus: RecruitingEmploymentStatusEnum
  payType?: RecruitingPayTypeEnum
  firstName?: string
  lastName?: string
  recipientEmail?: string
  isSendEmail: boolean
}
